import { proxyCustomElement, HTMLElement, h } from '@stencil/core/internal/client';
import { W as WppIcon } from './WppIcon.js';

const wppIconCss = ":host{display:-ms-inline-flexbox;display:inline-flex;color:var(--wpp-prop-icon-color)}";

const WppIconBorderBottomDouble$1 = /*@__PURE__*/ proxyCustomElement(class WppIconBorderBottomDouble extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    this.__attachShadow();
    this.size = 'm';
    this.width = undefined;
    this.height = undefined;
    this.color = 'var(--wpp-icon-color)';
  }
  render() {
    return (h(WppIcon, { name: "wpp-icon-border-bottom-double", width: this.width, height: this.height, size: this.size, color: this.color }, h("path", { d: "M8 3.75C8 3.33579 8.33579 3 8.75 3H11.25C11.6642 3 12 3.33579 12 3.75C12 4.16421 11.6642 4.5 11.25 4.5H8.75C8.33579 4.5 8 4.16421 8 3.75ZM5.45336 4.60266C5.06604 4.75429 4.75715 5.0623 4.60436 5.44903C4.59564 5.48051 4.58476 5.51178 4.57165 5.54266C4.40983 5.92387 3.96962 6.10173 3.58841 5.93991C3.20723 5.77812 3.02937 5.33798 3.1911 4.9568H3.18629C3.48957 4.1391 4.1391 3.48957 4.9568 3.18629V3.19061C5.33798 3.02889 5.77812 3.20675 5.93991 3.58792C6.10173 3.96913 5.92387 4.40935 5.54266 4.57116C5.51319 4.58367 5.48337 4.59415 5.45336 4.60266ZM15.3971 5.44903C15.2443 5.0623 14.9354 4.75429 14.5481 4.60266C14.5181 4.59415 14.4883 4.58367 14.4588 4.57116C14.0776 4.40935 13.8997 3.96913 14.0616 3.58792C14.2233 3.20675 14.6635 3.02889 15.0447 3.19061V3.18629C15.8624 3.48957 16.5119 4.1391 16.8152 4.9568H16.8104C16.9721 5.33798 16.7942 5.77812 16.4131 5.93991C16.0318 6.10173 15.5916 5.92387 15.4298 5.54266C15.4167 5.51178 15.4058 5.48051 15.3971 5.44903ZM3.75 11C3.33579 11 3 10.6642 3 10.25V8.75C3 8.33579 3.33579 8 3.75 8C4.16421 8 4.5 8.33579 4.5 8.75V10.25C4.5 10.6642 4.16421 11 3.75 11ZM15.5 10.25C15.5 10.6642 15.8358 11 16.25 11C16.6642 11 17 10.6642 17 10.25V8.75C17 8.33579 16.6642 8 16.25 8C15.8358 8 15.5 8.33579 15.5 8.75V10.25ZM3 16.25C3 15.8358 3.33579 15.5 3.75 15.5H16.25C16.6642 15.5 17 15.8358 17 16.25C17 16.6642 16.6642 17 16.25 17H3.75C3.33579 17 3 16.6642 3 16.25ZM3.75 13C3.33579 13 3 13.3358 3 13.75C3 14.1642 3.33579 14.5 3.75 14.5H16.25C16.6642 14.5 17 14.1642 17 13.75C17 13.3358 16.6642 13 16.25 13H3.75Z", fill: "currentColor" })));
  }
  static get registryIs() { return "wpp-icon-border-bottom-double-v2-21-0"; }
  static get style() { return wppIconCss; }
}, [1, "wpp-icon-border-bottom-double", "wpp-icon-border-bottom-double-v2-21-0", {
    "size": [1],
    "width": [2],
    "height": [2],
    "color": [1]
  }]);
function defineCustomElement$1() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["wpp-icon-border-bottom-double-v2-21-0"];
  components.forEach(tagName => { switch (tagName) {
    case "wpp-icon-border-bottom-double-v2-21-0":
      if (!customElements.get(tagName)) {
        customElements.define(tagName, WppIconBorderBottomDouble$1);
      }
      break;
  } });
}

const WppIconBorderBottomDouble = WppIconBorderBottomDouble$1;
const defineCustomElement = defineCustomElement$1;

export { WppIconBorderBottomDouble, defineCustomElement };
